/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FiltroUpdateDTO
 */
export interface FiltroUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof FiltroUpdateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof FiltroUpdateDTO
     */
    espressione?: string;
}

/**
 * Check if a given object implements the FiltroUpdateDTO interface.
 */
export function instanceOfFiltroUpdateDTO(value: object): value is FiltroUpdateDTO {
    return true;
}

export function FiltroUpdateDTOFromJSON(json: any): FiltroUpdateDTO {
    return FiltroUpdateDTOFromJSONTyped(json, false);
}

export function FiltroUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FiltroUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'espressione': json['espressione'] == null ? undefined : json['espressione'],
    };
}

export function FiltroUpdateDTOToJSON(value?: FiltroUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'espressione': value['espressione'],
    };
}

